import { observable, makeObservable, action } from 'mobx';

export type SourceType =
  | 'google'
  | 'microsoft'
  | 'icloud'
  | 'bhive'
  | 'personal'
  | 'shared'
  | 'Bhive';

export interface ISourceData {
  type: SourceType;
  accountId: string;
  syncState: string;
  lastSyncedAt: number;
}

export interface ISource {
  id: number;
  email: string;
  name: string;
  sourceData: ISourceData;
  createdAt: number;
}

export class SourceModelV2 {
  @observable id: number;
  @observable email: string;
  @observable name: string;
  @observable sourceData: ISourceData;
  @observable providerImage?: string;
  @observable providerImageSmall?: string;
  @observable createdAt: number;

  constructor() {
    makeObservable(this);
  }

  @action
  static fromResponseDto(dto: ISource): SourceModelV2 {
    const sourceModel = new SourceModelV2();
    sourceModel.id = dto.id;
    sourceModel.email = dto.email;
    sourceModel.name = dto.name;
    sourceModel.sourceData = dto.sourceData;
    sourceModel.createdAt = dto.createdAt;
    return sourceModel;
  }
}
